import React from 'react';
import t from '@rcm/i18n-client';
function Alert(props) {
    return <div className="alert alert-warning">{t(props.text)}</div>;
}
export default Alert;